import { render } from "./ProductRecommendList.vue?vue&type=template&id=25e205d2&scoped=true"
import script from "./ProductRecommendList.vue?vue&type=script&lang=js"
export * from "./ProductRecommendList.vue?vue&type=script&lang=js"

import "./ProductRecommendList.vue?vue&type=style&index=0&id=25e205d2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e205d2"]])

export default __exports__